'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BASE_18N_KEY = 'learningCenter.practicalExercise';
const BASE_CLASS_NAME = 'practical-exercise-instructions';
const PracticalExerciseInstructions = ({
  description = '',
  inProgress,
  isGraded,
  isManuallyApproved,
  name
}) => {
  const splitText = description.split(/\r?\n/).filter(Boolean);
  return /*#__PURE__*/_jsxs("div", {
    className: BASE_CLASS_NAME,
    children: [/*#__PURE__*/_jsx("h4", {
      children: name
    }), /*#__PURE__*/_jsx("span", {
      className: "is--heading-7",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_18N_KEY}.instructions.title`
      })
    }), /*#__PURE__*/_jsx("div", {
      className: `${BASE_CLASS_NAME}__description`,
      children: splitText.map((line, index) => /*#__PURE__*/_jsx("p", {
        children: line
      }, index))
    }), /*#__PURE__*/_jsxs(UIList, {
      className: `${BASE_CLASS_NAME}__list`,
      styled: true,
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `${BASE_18N_KEY}.instructions.${inProgress ? 'continue' : 'start'}`
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_18N_KEY}.instructions.${isManuallyApproved ? 'submitManual' : 'submitAutomatic'}`
      })]
    }), isGraded && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "is--heading-7",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${BASE_18N_KEY}.reminder.title`
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_18N_KEY}.reminder.required`
      })]
    })]
  });
};
PracticalExerciseInstructions.propTypes = {
  description: PropTypes.string,
  inProgress: PropTypes.bool,
  isGraded: PropTypes.bool,
  isManuallyApproved: PropTypes.bool,
  name: PropTypes.string
};
export default PracticalExerciseInstructions;